import { Component, OnInit } from '@angular/core';

import {LanguageService} from '../../language/language.service';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-optymalizacja-systemow',
  templateUrl: './optymalizacja-systemow.component.html',
  styleUrls: ['../pages.scss','./optymalizacja-systemow.component.scss']
})
export class OptymalizacjaSystemowComponent implements OnInit {

  constructor(
    private meta: Meta,
    private titleService: Title,
    public languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.languageService.getLang('systems optimization title', 'seo'));
    this.meta.updateTag({
      name: 'description',
      content: this.languageService.getLang('systems optimization desc', 'seo')
    });
  }
}
